import { stringify } from 'qs';
import request from '@/utils/request';

/** 实时督导、课后督导 分页列表查询 */
export async function conferencePage(params) {
  return request(`/api/blade-interact/supervisionRecord/conferencepage?${stringify(params)}`);
}
/** 异常回溯 */
export async function abnormalpage(params) {
  return request(`/api/blade-interact/supervisionRecord/abnormalpage?${stringify(params)}`);
}
/** 督导查询 */
export async function selectconferencepage(params) {
  return request(`/api/blade-interact/supervisionRecord/selectconferencepage?${stringify(params)}`);
}
/** 我的督导 */
export async function myconferencepage(params) {
  return request(`/api/blade-interact/supervisionRecord/myconferencepage?${stringify(params)}`);
}
/** 督导评分标准 */
export async function planDetail(params) {
  return request(`/api/blade-interact/supervisionPlan/detail?${stringify(params)}`);
}
